// Components/MessagesArea/hooks/useScrollManager.js
import { useEffect, useCallback } from 'react';

export const useScrollManager = ({
    messagesContainerRef,
    endOfMessagesRef,
    hasMore,
    isLoadingMore,
    loadMoreMessages
}) => {
    // Manejar el evento de scroll
    const handleScroll = useCallback(() => {
        const container = messagesContainerRef.current;
        // Si el scroll está cerca del top (< 100px), cargar mensajes más antiguos
        if (container && container.scrollTop < 100 && !isLoadingMore && hasMore) {
            loadMoreMessages();
        }
    }, [hasMore, isLoadingMore, loadMoreMessages]);

    // Hacer scroll al último mensaje cuando se carga inicialmente
    useEffect(() => {
        const endOfMessages = endOfMessagesRef?.current;
        const container = messagesContainerRef?.current;
        
        if (endOfMessages && container) {
            const scrollToBottom = () => {
                try {
                    // Hacer scroll al final de los mensajes (mensajes más recientes)
                    endOfMessages.scrollIntoView({ behavior: 'auto' });
                } catch (error) {
                    // console.error("Error al hacer scroll:", error);
                }
            };
            
            // Use requestAnimationFrame to ensure DOM is fully rendered
            const timeoutId = setTimeout(scrollToBottom, 150);
            
            // Cleanup timeout to prevent memory leaks
            return () => clearTimeout(timeoutId);
        }
    }, [messagesContainerRef, endOfMessagesRef]);

    return { handleScroll };
};